<template>
    <div class="mt-4">
        <h2 class="font-bold uppercase tracking-wider">{{ $t("topics.offers") }}</h2>
        <!-- DER UEBERHANG GEHOERT IN DIE TABELLE, NICHT IN DIE SEITE (dieselbe
             Loesung wie B-1 in `ApartmentBudgetTable.vue`): mit Gebuehr,
             Honorar und Total sind es elf Spalten, und bei 768 px passt das
             nicht mehr. Ohne diesen Wrapper waere der naechste scrollbare
             Vorfahre das `main` des Layouts — die Tabelle waere dann
             abgeschnitten ODER die ganze Seite wuerde quer scrollen. -->
        <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200 mt-2 md:mt-6">
                <thead class="bg-minplan-lightgreybeige">
                    <tr>
                        <th class="px-3 py-2 text-left text-xs font-medium text-minplan-beige uppercase">
                            {{ $t("offers.description") }}
                        </th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-minplan-beige uppercase">
                            {{ $t("offers.bkpTitle") }}
                        </th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-minplan-beige uppercase">
                            {{ $t("offers.date") }}
                        </th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-minplan-beige uppercase">
                            {{ $t("offers.supplier") }}
                        </th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-minplan-beige uppercase text-right">
                            {{ $t("offers.netCost") }}
                        </th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-minplan-beige uppercase text-right">
                            {{ $t("offers.taxRate") }}
                        </th>
                        <!-- Thema 2 (Auftrag Luca, 23.09.2026): Gebuehr, Honorar und das
                             Zeilen-Total. Dieselben Begriffe wie in der Abrechnung der
                             Wohnung, deshalb dieselben Schluessel. Die Spalte
                             "MWST-Satz" bleibt im Unterschied zum Prototyp stehen: sie
                             ist die einzige Stelle, an der ein abweichender Steuersatz
                             je Offerte sichtbar ist. -->
                        <th v-if="showBaseFee" class="px-3 py-2 text-xs font-medium text-minplan-beige uppercase text-right">
                            {{ $t("apartments.baseFee") }}
                        </th>
                        <th v-if="showConsultancyFee" class="px-3 py-2 text-xs font-medium text-minplan-beige uppercase text-right">
                            {{ $t("apartments.consultancyFee") }}
                        </th>
                        <th v-if="showFees" class="px-3 py-2 text-xs font-medium text-minplan-beige uppercase text-right">
                            {{ $t("apartments.totalColumn") }}
                        </th>
                        <th class="px-3 py-2 text-center text-xs font-medium text-minplan-beige uppercase">
                            {{ $t("offers.version") }}
                        </th>
                        <th class="px-3 py-2 text-right text-xs font-medium text-minplan-beige uppercase">
                            {{ $t("offers.actions") }}
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="offer in offers" :key="offer.uuid">
                        <td class="px-3 py-2 text-sm font-medium text-gray-900">
                            {{ offer.title }}
                            <span v-if="offer.is_credit" class="ml-1 inline-block bg-red-100 text-red-700 text-xs px-2 py-0.5 rounded-full">{{ $t("offers.type.credit") }}</span>
                            <button type="button" v-if="offer.comment" @click="showComments(offer)" class="inline-block bg-minplan-beige rounded-full px-2 py-1">
                                <ChatAltIcon class="h-5 w-5 text-minplan-darkbeige inline-block" />
                            </button>
                            <!-- Digital Sign Status -->
                            <div v-if="offer.signature_status" class="mt-1 flex flex-col gap-1 text-xs font-normal text-gray-500">
                                <span title="Digital Signature Progress" v-if="offer.signature_status.total > 0">
                                    Signaturen: {{ offer.signature_status.completed }} / {{ offer.signature_status.total }}
                                </span>
                                <span v-if="offer.signature_status.pending_names.length > 0" class="text-xs text-red-500 whitespace-normal">
                                    Ausstehend: {{ offer.signature_status.pending_names.join(', ') }}
                                </span>
                            </div>
                        </td>
                        <td class="px-3 py-2 text-sm text-gray-900">{{ offer.bkp }}</td>
                        <td class="px-3 py-2 text-sm text-gray-900">{{ offer.createdAt }}</td>
                        <td class="px-3 py-2 text-sm text-gray-900">{{ offer.supplier }}</td>
                        <td class="px-3 py-2 text-sm text-gray-900 text-right">
                            <div class="flex items-center justify-end gap-2">
                                <span :class="{ 'text-red-600': offer.is_credit }">{{ offer.netCost }}</span>
                                <button
                                    v-if="offer.price_calculation_json && offer.price_calculation_json.length > 0"
                                    type="button"
                                    @click="openPriceCalcView(offer)"
                                    class="relative inline-flex"
                                    title="View Price Calculation"
                                >
                                    <svg class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 13h.01M13 13h.01M13 17h.01M17 7h.01M17 13h.01M17 17h.01M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z" />
                                    </svg>
                                    <span class="absolute -top-1 -right-1 flex items-center justify-center h-4 w-4 bg-minplan-darkbeige text-white text-[10px] font-bold rounded-full border border-white">
                                        {{ offer.price_calculation_json.length }}
                                    </span>
                                </button>
                            </div>
                        </td>
                        <td class="px-3 py-2 text-sm text-gray-900 text-right">
                            {{ offer.taxRate }}%
                        </td>
                        <!-- EIN STRICH IST KEIN NULLBETRAG: liefert der Server `null`,
                             faellt der Satz auf diese Offerte nicht an. "0.00" hiesse,
                             er faellt an und ergibt nichts — eine andere Aussage. -->
                        <td v-if="showBaseFee" class="px-3 py-2 text-sm text-gray-900 text-right">
                            <span v-if="hasAmount(offer.baseFee)">{{ offer.baseFee }}</span>
                            <span v-else class="text-gray-400">&mdash;</span>
                        </td>
                        <td v-if="showConsultancyFee" class="px-3 py-2 text-sm text-gray-900 text-right">
                            <span v-if="hasAmount(offer.consultancyFee)">{{ offer.consultancyFee }}</span>
                            <span v-else class="text-gray-400">&mdash;</span>
                        </td>
                        <td v-if="showFees" class="px-3 py-2 text-sm text-gray-900 text-right">
                            {{ offer.totalWithFees }}
                        </td>
                        <td class="px-3 py-2 text-sm text-gray-900 text-center">
                            <button v-if="offer.historyLink" type="button" class="inline-flex items-center justify-center">
                                {{ offer.version }}
                                <InformationCircleIcon @click="openModal(offer.historyLink)" class="h-5 w-5 ml-2 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                            </button>
                        </td>
                        <td class="px-3 py-2 text-right text-sm">
                            <button v-if="offer.filename && isViewable(offer.filename)" type="button" @click="viewFile(offer.viewLink, offer.filename)" title="View" class="mr-2">
                                <EyeIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                            </button>
                            <button type="button" @click="download(offer)" v-if="offer.filename" title="Download" class="mr-2">
                                <CloudDownloadIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                            </button>

                            <!-- NEW SIGNING BUTTONS -->
                            <button v-if="offer.signature_status && (offer.signature_status.total > 0 || offer.signature_status.is_self_sign === 'Yes')" type="button" @click="showSignatureHistory(offer)" title="Signature History" class="mr-2">
                                <svg class="h-5 w-5 ml-2 text-minplan-darkbeige hover:text-minplan-darkgreybeige" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </button>
                        
                            <button v-if="offer.currentUserNeedsToSign" type="button" @click="openSignModal(offer)" title="Sign offer" class="mr-2">
                                <PencilAltIcon class="h-5 w-5 text-minplan-blue hover:text-minplan-darkgreybeige" />
                            </button>

                            <button v-if="offer.can_admin_self_sign" type="button" :disabled="loadingAdminSignUuid === offer.uuid" @click="adminSelfSign(offer)" class="mr-2 inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded shadow-sm hover:bg-blue-200 transition disabled:opacity-50" title="Admin Self Sign">
                                <span v-if="loadingAdminSignUuid === offer.uuid" class="flex items-center gap-1">
                                    <svg class="animate-spin h-3 w-3 text-blue-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                    ...
                                </span>
                                <span v-else>Eigene Signatur</span>
                            </button>
                            <!-- / NEW SIGNING BUTTONS -->

                            <button v-if="offer.editLink" type="button" @click="openModal(offer.editLink)" class="mr-2">
                                <PencilIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                            </button>
                            <button v-if="offer.replaceLink" type="button" @click="openModal(offer.replaceLink)" class="mr-2">
                                <RefreshIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                            </button>
                            <button v-if="offer.removeLink" type="button" @click="openModal(offer.removeLink)">
                                <TrashIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tfoot class="border-t">
                    <!-- DIE SUMMENZEILE STEHT SPALTENWEISE UNTER IHRER SPALTE: Betrag,
                         Gebuehr und Honorar je unter der eigenen, das Netto-Total unter
                         "Total". Ohne Gebuehren-Spalten bleibt die Zeile exakt wie bisher
                         — der Betrag steht dann unter "Betrag exkl. MWST".

                         SIE ADDIERT ABER NICHT DIE ZEILEN UEBER IHR, und das ist Absicht
                         (Entscheid Luca, 23.09.2026, Gate-Befund D1). Die beiden
                         Gebuehren-Fusszeilen sind die Summe ihrer Spalte, das Netto-Total
                         folgt dagegen dem GESPEICHERTEN Betrag der Aenderung
                         (`ModificationTotal::netTotal()` rechnet auf `cost_excl` und
                         nicht auf der Summe der gerundeten Offerten-Zeilen). Beide Wege
                         koennen um einen 5-Rappen-Schritt auseinanderliegen — in der
                         Testfixture 1'273.25 gegen 1'273.30.

                         Der gespeicherte Betrag gewinnt, weil Invariante 6 schwerer wiegt:
                         Liste, Abrechnung, Offerte und Mail nennen fuer dieselbe Aenderung
                         EINE Zahl; genau dass sie es nicht taten, war Peters Befund. Die
                         Abweichung ist in
                         `OfferFeeColumnsTest::test_the_net_total_should_follow_the_stored_amount_and_may_differ_from_the_addition_of_the_rows()`
                         festgenagelt, damit sie niemand spaeter als Fehler "repariert". -->
                    <tr>
                        <td colspan="4" class="px-3 py-2 text-sm text-right">
                            {{ $t("offers.totalWithoutTax") }}
                        </td>
                        <td class="px-3 py-2 text-sm text-right">{{ netCost }}</td>
                        <template v-if="showFees">
                            <td></td>
                            <td v-if="showBaseFee" class="px-3 py-2 text-sm text-right">{{ fees.baseFee }}</td>
                            <td v-if="showConsultancyFee" class="px-3 py-2 text-sm text-right">{{ fees.consultancyFee }}</td>
                            <td class="px-3 py-2 text-sm text-right font-bold">{{ fees.netTotal }}</td>
                            <td colspan="2"></td>
                        </template>
                        <td v-else colspan="3"></td>
                    </tr>
                    <tr>
                        <!-- Die Beschriftung laeuft bis vor die Betragsspalte, der Betrag
                             steht darunter. -->
                        <td :colspan="footerLabelSpan" class="px-3 py-2 text-sm text-right">
                            {{ $t("offers.taxAmount") }}
                        </td>
                        <td class="px-3 py-2 text-sm text-right">{{ showFees ? fees.taxAmount : taxAmount }}</td>
                        <td :colspan="footerTrailingSpan"></td>
                    </tr>
                    <tr>
                        <td :colspan="footerLabelSpan" class="px-3 py-2 text-sm font-bold text-right">
                            {{ $t("offers.totalWithTax") }}
                        </td>
                        <td class="px-3 py-2 text-sm font-bold text-right">{{ showFees ? fees.grossTotal : cost }}</td>
                        <td :colspan="footerTrailingSpan"></td>
                    </tr>
                    <tr>
                        <!-- Linksbuendig unter der ganzen Tabelle: rechtsbuendig auf vier
                             von acht Spalten stand der Hinweis mitten im Nichts, und mit
                             den Gebuehren-Spalten waere er unter einem Betrag gelandet. -->
                        <td :colspan="columnCount" class="px-3 py-2 text-sm text-left opacity-50">
                            {{ $t("offers.vatInfo") }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- Signing Modal -->
        <jet-dialog-modal :show="!!signingUrl" @close="signingUrl = null" max-width="full">
            <template #title>
                <div class="flex justify-between items-center pr-4">
                    <span>Dokument signieren</span>
                    <button @click="checkBuyerCompletion" class="bg-emerald-600 text-white px-4 py-1 rounded text-sm font-bold shadow hover:bg-emerald-700 transition">
                        {{ $t("documents.finishedSigning") }}
                    </button>
                </div>
            </template>
            <template #content>
                <div class="w-full h-[85vh] border rounded overflow-hidden bg-gray-50 relative">
                    <iframe v-if="signingUrl" :src="signingUrl" class="w-full h-full" frameborder="0"></iframe>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-between w-full">
                    <p class="text-xs text-gray-500 italic pt-2">{{ $t("documents.clickGreenButton") }}</p>
                    <jet-secondary-button @click="signingUrl = null">
                        {{ $t("Close") }}
                    </jet-secondary-button>
                </div>
            </template>
        </jet-dialog-modal>

        <!-- Comments Modal -->
        <jet-dialog-modal :show="showModal" @close="closeModal">
            <template #title>
                {{ $t("offers.showComment") }}
            </template>
            <template #content>
                {{ currentComment }}
            </template>
            <template #footer>
                <button @click="closeModal" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.close") }}
                </button>
            </template>
        </jet-dialog-modal>

        <!-- Signature History Modal -->
        <jet-dialog-modal :show="!!historyOffer" @close="historyOffer = null" max-width="2xl">
            <template #title>
                Signaturverlauf der Offerte
            </template>
            <template #content>
                <div v-if="historyOffer?.signature_status" class="overflow-x-auto">
                    <table class="min-w-full divide-y border text-sm">
                        <thead class="bg-gray-50">
                            <tr>
                                <th class="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">Unterzeichner</th>
                                <th class="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                <th class="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">Datum</th>
                                <th class="px-6 py-3 text-left font-medium text-gray-500 uppercase tracking-wider">Aktion</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y">
                            <tr v-for="(buyer, idx) in historyOffer.signature_status.history" :key="'buyer-'+idx">
                                <td class="px-6 py-4 whitespace-nowrap">{{ buyer.buyer_name }}</td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span v-if="buyer.is_sign === 'Yes'" class="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Unterzeichnet</span>
                                    <span v-else-if="buyer.is_sign === 'reject'" class="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Abgelehnt</span>
                                    <span v-else class="px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Ausstehend</span>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-gray-500">
                                    {{ buyer.sign_at ? formatDate(buyer.sign_at) : 'N/A' }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap flex gap-2">
                                    <button v-if="buyer.is_sign === 'Yes'" @click="download(historyOffer)" class="text-emerald-600 hover:text-emerald-700 font-medium text-xs border border-emerald-600 px-2 py-1 rounded">
                                        {{ $t("actions.download") }}
                                    </button>
                                    <button v-if="buyer.is_sign === 'Yes' && isViewable(historyOffer.filename)" @click="viewFile(historyOffer.viewLink, historyOffer.filename)" class="text-emerald-600 hover:text-emerald-700 font-medium text-xs border border-emerald-600 px-2 py-1 rounded">
                                        {{ $t("actions.view") }}
                                    </button>
                                    <template v-if="buyer.is_sign === 'No'">
                                        <button v-if="!$page.props.user.buyer_id" :disabled="resendingEmailId === buyer.buyer_id" @click="resendEmail(buyer)" class="text-minplan-blue hover:text-minplan-darkblue font-medium text-xs border border-minplan-blue px-2 py-1 rounded disabled:opacity-50">
                                            {{ resendingEmailId === buyer.buyer_id ? $t("orderModifications.pendingSignatures.sending") : $t("orderModifications.pendingSignatures.resendEmail") }}
                                        </button>
                                        <button v-if="isSignableByMe(historyOffer, buyer)" @click="openSignModal(historyOffer, buyer)" class="inline-flex items-center gap-1 text-emerald-600 hover:text-emerald-700 font-bold text-xs border border-emerald-600 px-2 py-1 rounded">
                                            <PencilAltIcon class="h-3 w-3" />
                                            {{ buyer.buyer_name ? $t("orderModifications.pendingSignatures.signNowFor", { name: buyer.buyer_name }) : $t("orderModifications.pendingSignatures.signNow") }}
                                        </button>
                                    </template>
                                </td>
                            </tr>
                            <tr v-if="$page.props.offer_document_digital_sign_mode === 'On'">
                                <td class="px-6 py-4 whitespace-nowrap">Admin (Eigene Signatur)</td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <span v-if="historyOffer.signature_status.is_self_sign === 'Yes'" class="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Unterzeichnet</span>
                                    <span v-else class="px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">Nicht unterzeichnet</span>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-gray-500">
                                    {{ historyOffer.signature_status.admin_sign_at ? formatDate(historyOffer.signature_status.admin_sign_at) : 'N/A' }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <button v-if="historyOffer.signature_status.is_self_sign === 'Yes'" @click="download(historyOffer)" class="text-emerald-600 hover:text-emerald-700 font-medium text-xs border border-emerald-600 px-2 py-1 rounded">
                                        Herunterladen
                                    </button>
                                    <button v-if="historyOffer.signature_status.is_self_sign === 'Yes' && isViewable(historyOffer.filename)" @click="viewFile(historyOffer.viewLink, historyOffer.filename)" class="text-emerald-600 hover:text-emerald-700 font-medium text-xs border border-emerald-600 px-2 py-1 rounded">
                                        Ansehen
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template #footer>
                <jet-secondary-button @click="historyOffer = null">
                    Schliessen
                </jet-secondary-button>
            </template>
        </jet-dialog-modal>

        <teleport to="body">
            <digital-signature-config 
                v-if="showAdminSignConfig"
                :pdf-base64="adminSignPdfBase64"
                :file-name="adminSignOffer?.title"
                :auth-user-id="$page.props.user.id"
                is-admin-sign-only
                @cancel="showAdminSignConfig = false"
                @done="finalizeAdminSign"
            />

            <price-calculation-modal
                v-if="viewPriceCalcOffer !== null"
                :show="viewPriceCalcOffer !== null"
                :title="$t('offers.priceCalc.viewTitle')"
                :units="[]"
                :initial-rows="viewPriceCalcOffer ? viewPriceCalcOffer.price_calculation_json : []"
                :readonly="true"
                @cancel="closePriceCalcView"
            />

            <file-preview-modal
                :show="previewFile !== null"
                :file-url="previewFile?.url"
                :file-name="previewFile?.name"
                @close="previewFile = null"
            />
        </teleport>
    </div>
</template>

<script>
import {
    CloudDownloadIcon,
    PencilIcon,
    InformationCircleIcon,
    RefreshIcon,
    TrashIcon,
    ChatAltIcon,
    PencilAltIcon,
    EyeIcon,
} from "@heroicons/vue/outline";
import { downloadFile } from "@/Shared/Utils/downloader";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import DigitalSignatureConfig from "@/Shared/Components/Documents/Modals/DigitalSignatureConfig.vue";
import PriceCalculationModal from "@/Shared/Components/Offers/PriceCalculationModal.vue";
import FilePreviewModal from "@/Shared/Components/FilePreviewModal.vue";
import axios from "axios";
import { defineComponent } from "vue";

// `defineComponent()` statt des blanken `export default {}`: dieselbe Form wie
// in `ApartmentBudgetTable.vue`, weil der Vitest-Fall dieser Datei die Optionen
// direkt importiert und der Wrapper ihm (und der IDE) den Komponententyp gibt.
// Verhaltensgleich — er reicht sein Argument unveraendert durch.
export default defineComponent({
    name: "OrderModificationOfferTable",
    props: ["offers", "cost", "netCost", "taxAmount", "fees"],
    components: {
        CloudDownloadIcon,
        PencilIcon,
        InformationCircleIcon,
        RefreshIcon,
        TrashIcon,
        ChatAltIcon,
        JetDialogModal,
        JetSecondaryButton,
        PencilAltIcon,
        DigitalSignatureConfig,
        PriceCalculationModal,
        FilePreviewModal,
        EyeIcon,
    },
    computed: {
        // `fees` kommt fertig gerechnet vom Server (`modification.fees`) — aus
        // derselben Quelle wie die Liste der Bestellungsaenderungen und die
        // Abrechnung. Fehlt der Schalter, bleibt die Tabelle wie bisher: im
        // Budget-Modus und bei einer nicht verrechneten Aenderung gibt es
        // Gebuehr und Honorar gar nicht.
        showFees() {
            return !!(this.fees && this.fees.showFees);
        },
        showBaseFee() {
            return this.showFees && !!this.fees.showBaseFee;
        },
        showConsultancyFee() {
            return this.showFees && !!this.fees.showConsultancyFee;
        },
        // Bezeichnung, BKP, Datum, Unternehmer, Betrag, MWST-Satz, Version,
        // Aktionen — dazu die zugeschalteten Gebuehren-Spalten.
        columnCount() {
            return (
                8 +
                (this.showBaseFee ? 1 : 0) +
                (this.showConsultancyFee ? 1 : 0) +
                (this.showFees ? 1 : 0)
            );
        },
        // Alles links der Betragsspalte. Ohne Gebuehren steht der Betrag unter
        // "Betrag exkl. MWST" (vier Spalten davor), mit Gebuehren unter "Total".
        footerLabelSpan() {
            if (!this.showFees) {
                return 4;
            }

            return 6 + (this.showBaseFee ? 1 : 0) + (this.showConsultancyFee ? 1 : 0);
        },
        // Version und Aktionen; ohne Gebuehren zusaetzlich die Spalte MWST-Satz.
        footerTrailingSpan() {
            return this.showFees ? 2 : 3;
        },
    },
    data() {
        return {
            showModal: false,
            currentComment: null,
            signingUrl: null,
            signingOfferUuid: null,
            signingBuyerId: null,
            signingOpenSignId: null,
            historyOffer: null,
            showAdminSignConfig: false,
            adminSignPdfBase64: null,
            adminSignOffer: null,
            pollingInterval: null,
            resendingEmailId: null,
            loadingAdminSignUuid: null,
            viewPriceCalcOffer: null,
            previewFile: null,
        };
    },
    watch: {
        signingUrl(newVal) {
            if (newVal) {
                this.startPolling();
            } else {
                this.stopPolling();
            }
        }
    },
    beforeUnmount() {
        this.stopPolling();
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('autosign')) {
            const filterOfferUuid = params.get('offer');
            const items = Array.isArray(this.offers) ? this.offers : Object.values(this.offers);
            const offer = items.find(d => {
                const matchesUuid = filterOfferUuid ? (d.uuid === filterOfferUuid) : true;
                return matchesUuid && d.currentUserNeedsToSign;
            });
            if (offer) {
                this.openSignModal(offer);
            }
        }
    },
    methods: {
        // Der Strich gilt genau fuer `null` (der Server sagt: faellt nicht an).
        // "0.00" ist ein Betrag und wird als Betrag gezeigt.
        hasAmount(value) {
            return value !== null && value !== undefined;
        },
        isViewable(fileName) {
            if (!fileName) return false;
            const ext = fileName.toLowerCase().split('.').pop();
            return ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext);
        },
        viewFile(url, name) {
            this.previewFile = { url, name };
        },
        download(offer) {
            downloadFile(offer.downloadLink, offer.filename);
        },
        openModal(link) {
            this.$inertia.visitInModal(link);
        },
        openPriceCalcView(offer) {
            this.viewPriceCalcOffer = offer;
        },
        closePriceCalcView() {
            this.viewPriceCalcOffer = null;
        },
        showComments(offer) {
            this.showModal = true;
            this.currentComment = offer.comment;
        },
        closeModal() {
            this.showModal = false;
            this.currentComment = null;
        },
        showSignatureHistory(offer) {
            this.historyOffer = offer;
        },
        // Der Server sagt, welche Kaeufer-Zeilen dieses Login unterschreiben
        // darf. Frueher verglich das Frontend gegen die EINE `user.buyer_id`
        // aus den Shared Props; ein Login mit mehreren Kaeufer-Zeilen traf
        // damit hoechstens auf einer Wohnung zu. `buyer_id` kommt als String,
        // die Liste als Zahl — ohne `Number()` faende `includes` nie etwas.
        isSignableByMe(offer, buyer) {
            const ids = offer.signature_status?.signable_buyer_ids ?? [];

            return ids.includes(Number(buyer.buyer_id));
        },
        // Die URL kommt aus der ZEILE, nicht mehr aus `currentUserSigningUrl`:
        // bei zwei unterschreibbaren Zeilen ist ein einzelner Wert nicht mehr
        // eindeutig.
        // Die erste noch offene Zeile, die dieses Login unterschreiben darf —
        // fuer die Aufrufe ohne ausgewaehlte Zeile (Signatur-Symbol in der
        // Zeile, Direkteinstieg ueber den `?offer=`-Parameter).
        firstSignableRow(offer) {
            const ids = offer.signature_status?.signable_buyer_ids ?? [];

            return (
                (offer.signature_status?.history ?? []).find(
                    (row) =>
                        (row.is_sign ?? "No") === "No" &&
                        ids.includes(Number(row.buyer_id)),
                ) ?? null
            );
        },
        openSignModal(offer, buyer = null) {
            const row = buyer ?? this.firstSignableRow(offer);

            if (row?.url) {
                this.historyOffer = null; // Close history popup
                this.signingUrl = row.url;
                this.signingBuyerId = Number(row.buyer_id);
                this.signingOfferUuid = offer.uuid;
                this.signingOpenSignId = offer.digital_sign_json?.docId; 
                
                if (!this.signingOpenSignId) {
                    this.$notify({ group: "error", title: "Konfigurationsfehler", text: "Signaturkonfiguration fehlt. Bitte kontaktieren Sie den Support." });
                }
            } else {
                this.$notify({ group: "error", title: "Fehler", text: "Signatur-URL nicht gefunden." });
            }
        },
        async adminSelfSign(offer) {
            this.loadingAdminSignUuid = offer.uuid;
            try {
                this.$notify({ group: "info", title: "Information", text: "Eigene Signatur wird initialisiert..." });
                const res = await axios.post('/documents/digital-sign/buyer-signed-pdf', {
                    documentUuid: offer.uuid
                });
                
                if (res.data?.ok && res.data?.pdf) {
                    this.adminSignOffer = offer;
                    this.adminSignPdfBase64 = res.data.pdf;
                    this.showAdminSignConfig = true;
                } else {
                    this.$notify({ group: "error", title: "Fehler", text: res.data?.error || "Fehler beim Initialisieren der eigenen Signatur." });
                }
            } catch (e) {
                console.error(e);
                this.$notify({ group: "error", title: "Fehler", text: "Initialisierung fehlgeschlagen." });
            } finally {
                this.loadingAdminSignUuid = null;
            }
        },
        async finalizeAdminSign(payload) {
            this.showAdminSignConfig = false;
            try {
                const res = await axios.post('/documents/digital-sign/complete-admin', {
                    documentUuid: this.adminSignOffer.uuid,
                    finalDocId: payload.digital_sign_json.docId
                });
                
                if (res.data?.ok) {
                    this.$inertia.reload();
                    this.$notify({ group: "success", title: "Erfolg", text: "Eigene Signatur erfolgreich verarbeitet." });
                } else {
                    this.$notify({ group: "error", title: "Fehler", text: res.data?.error || "Abschlussprüfung fehlgeschlagen." });
                }
            } catch (e) {
                console.error(e);
                this.$notify({ group: "error", title: "Fehler", text: "Beim Abschließen der Signatur ist ein Fehler aufgetreten." });
            } finally {
                this.adminSignOffer = null;
                this.adminSignPdfBase64 = null;
            }
        },
        async checkBuyerCompletion(silent = false) {
            if (!this.signingOfferUuid) return;
            
            try {
                const res = await axios.post('/documents/digital-sign/complete-buyer', {
                    docId: this.signingOpenSignId,
                    documentUuid: this.signingOfferUuid,
                    buyerId: this.signingBuyerId,
                });
                
                if (res.data?.ok) {
                    this.stopPolling();
                    this.signingUrl = null;
                    this.signingOfferUuid = null;
                    this.signingOpenSignId = null;
                    this.$inertia.reload();
                    this.$notify({ group: "success", title: "Erfolg", text: "Unterschrift erfolgreich verarbeitet." });
                } else {
                    if (!silent) {
                        this.$notify({ group: "error", title: "Fehler", text: res.data?.error || "Abschlussprüfung fehlgeschlagen." });
                    }
                }
            } catch (e) {
                if (!silent) {
                    console.error(e);
                    this.$notify({ group: "error", title: "Fehler", text: "Beim Prüfen der Fertigstellung ist ein Fehler aufgetreten." });
                }
            }
        },
        startPolling() {
            this.stopPolling();
            const interval = (parseInt(this.$page.props.check_sign_complete_or_not_in_second) || 2) * 1000;
            this.pollingInterval = setInterval(() => {
                this.checkBuyerCompletion(true);
            }, interval);
        },

        stopPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        async resendEmail(buyer) {
            this.resendingEmailId = buyer.buyer_id;
            try {
                const res = await axios.post('/documents/digital-sign/resend-email', {
                    documentUuid: this.historyOffer.uuid,
                    buyerId: buyer.buyer_id
                });
                if (res.data?.ok) {
                    this.$notify({ group: "success", title: "Erfolg", text: "Erinnerungs-E-Mail versendet." });
                } else {
                    this.$notify({ group: "error", title: "Fehler", text: res.data?.error || "E-Mail konnte nicht erneut versendet werden." });
                }
            } catch (e) {
                console.error(e);
                this.$notify({ group: "error", title: "Fehler", text: "Etwas ist schiefgelaufen." });
            } finally {
                this.resendingEmailId = null;
            }
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const d = new Date(dateString);
            return d.toLocaleString();
        },
        isViewable(fileName) {
            if (!fileName) return false;
            const ext = fileName.toLowerCase().split('.').pop();
            return ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext);
        },
        viewFile(url, name) {
            const ext = name.toLowerCase().split('.').pop();
            if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext)) {
                window.Fancybox.show([{ src: url, type: "image" }]);
            } else {
                this.previewFile = { url, name };
            }
        }
    },
});
</script>

<style scoped></style>
